import { ApiClient } from "#/shared/api/client";

function extractErrorMessage(error) {
  const data = error?.data;

  if (Array.isArray(data?.errors) && data.errors.length > 0) {
    return data.errors.join(", ");
  }

  if (typeof data?.error === "string" && data.error.length > 0) {
    return data.error;
  }

  if (typeof data === "string" && data.length > 0 && !data.trim().startsWith("<")) {
    return data;
  }

  if (error?.status) {
    return `Server responded with ${error.status}`;
  }

  return error?.message || "An error occurred. Please try again.";
}

class CanonicalUpdateApi extends ApiClient {
  transform(data) {
    return data;
  }

  // Starts the background comparison; resolves to `{ token, status }`.
  async preview(previewUrl) {
    try {
      return await this.post(previewUrl);
    } catch (error) {
      // A 422 start still carries the rows/summary payload — surface it so
      // the review step can render the top-level errors.
      if (Array.isArray(error?.data?.rows)) {
        return error.data;
      }

      throw new Error(extractErrorMessage(error));
    }
  }

  // Resolves to `{ status }` (pending/expired), `{ status: "ready", rows,
  // summary, errors }`, or `{ status: "failed", errors }`.
  async previewStatus(statusUrl, token) {
    try {
      return await this.get(statusUrl, { token });
    } catch (error) {
      throw new Error(extractErrorMessage(error));
    }
  }

  async process(processUrl, { token }) {
    try {
      return await this.post(processUrl, { token });
    } catch (error) {
      // A 422 apply (e.g. the preview token expired while the review sat open)
      // carries `{ queued: false, errors }` — surface it so the store can show
      // the errors without closing the modal.
      if (error?.data?.queued === false) {
        return error.data;
      }

      throw new Error(extractErrorMessage(error));
    }
  }
}

let api;

export function createCanonicalUpdateApi() {
  api ??= new CanonicalUpdateApi();

  return api;
}
